import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import * as styles from './index.module.scss';

export const TurnstileHelpMessage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.turnstileHelp} data-test="turnstile-help">
      <Trans i18nKey="ui.turnstile.loadHelp">
        <a
          href={t('ui.turnstile.zendeskSupportUrlForTurnstile')}
          target="_blank"
          rel="noopener noreferrer"
        >
          こちら
        </a>
      </Trans>
    </div>
  );
};
